const TelegramIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="34" viewBox="0 0 36 34" fill="none">
      <path
        d="M13.0983 31.5745C11.9757 31.5745 12.1665 31.1242 11.7793 29.9887L8.47803 18.4467L33.8898 2.43164"
        fill="#558AA8"
      />
      <path
        d="M12.7183 31.5717C13.5846 31.5717 13.9673 31.1361 14.4509 30.6191L19.0712 25.6789L13.3079 21.8574"
        fill="#558AA8"
      />
      <path
        d="M14.1027 22.4388L27.4441 33.5379C28.9666 34.4837 30.0654 33.994 30.4446 31.9463L35.8752 3.12987C36.4312 0.619797 35.0255 -0.518656 33.5691 0.225898L1.68039 14.0717C-0.496313 15.0548 -0.483623 16.4222 1.28362 17.0315L9.46697 19.9075L28.4123 6.44884C29.3067 5.83814 30.1275 6.16646 29.4538 6.83975"
        fill="url(#paint0_linear_120_278)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_120_278"
          x1="40.4354"
          y1="-11.1947"
          x2="-5.12053"
          y2="9.13603"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9FEF94" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TelegramIcon;
